import {
  StatusEventPageSignalDataResponse
} from '@models/pages/status-event-page/status-event-page-signal-data-response';
import {StatusEventType} from '@constants/machine/status-event-signal/status-event-type.enum';
import {StatusEventSignalEventsDetails} from '@models/machine/status-event-signal/status-event-signal-events-details';

export class StatusEventGroupPageDisplayDetails {
  machineName: string;
  machineId: number | null;
  machineLocation: string;
  statusEventPageData: StatusEventPageData[];
  numberOfEvents = {
    errors: 0,
    warnings: 0,
    infos: 0,
    debugs: 0,
    inhibits: 0
  };
  totalCount: number = 0;

  constructor(machineName, machineId, machineLocation, statusEventPageData) {
    this.machineName = machineName || '';
    this.machineId = machineId || null;
    this.machineLocation = machineLocation || '';
    this.statusEventPageData = statusEventPageData;

    this.eventCounter(this.statusEventPageData);
  }

  private eventCounter(statusEventPageData: StatusEventPageData[]): void {
    statusEventPageData.forEach(({events}) => {
      events.forEach(({values}) => {
        values.forEach(({type}) => this.increaseCounter(type));
      });
    });
  }

  private increaseCounter(type: StatusEventType): void {
    switch (type) {
      case StatusEventType.FAILURE:
        this.numberOfEvents.errors++;
        this.totalCount++;
        break;
      case StatusEventType.WARNING:
        this.numberOfEvents.warnings++;
        this.totalCount++;
        break;
      case StatusEventType.INFO:
        this.numberOfEvents.infos++;
        this.totalCount++;
        break;
      case StatusEventType.DEBUG:
        this.numberOfEvents.debugs++;
        this.totalCount++;
        break;
      case StatusEventType.INHIBIT:
        this.numberOfEvents.inhibits++;
        this.totalCount++;
        break;
    }
  }
}

export interface StatusEventPageData {
  signalName: string;
  events: StatusEventPageSignalDataResponse[];
  statusEventPageId: number;
}

export interface StatusEventGroupPageDisplayDetailsInputData {
  machineStatusEventDetails: MachineStatusEventDetails[];
  statusEventPageData: {[key: string]: StatusEventPageSignalDataResponse[]};
}

interface MachineStatusEventDetails {
  machineId: number;
  machineLocation: string;
  machineName: string;
  machineStatusEventPageDetails: {statusEventPageId: number, statusEventsDetails: {[key: number]: StatusEventSignalEventsDetails}}[];
}
